import { LocalStorageService } from 'src/app/common/services/local-storage.service';
import { isCountryMX, isCountryPE } from "src/app/common/util/util";
import { IndexDBService } from "src/app/common/services/indexedDB.service";
import { isEndosso } from "./endoso-utils";

const localStorageService = new LocalStorageService();

const indexedDBService = new IndexDBService();

let productJSON: any;

let form: any;

export async function initFormAndProduct(): Promise<void> {
  if (isCountryPE()) {
    const resultForm = await indexedDBService.getItemByKey('form');
    form = resultForm;
    const resultProductJSON = await indexedDBService.getItemByKey('productJSON');
    productJSON = resultProductJSON;
  } else {
    form = localStorageService.get('form');
    productJSON = localStorageService.get('productJSON');
  }
}


export function reloadProductJSON(): void {
  productJSON = localStorageService.get('productJSON');
}
export function reloadform(): void {
  form = localStorageService.get('form');
}

export function setForm(formValue: any): void {
  form = formValue;
}

export function setProductJSON(productJSONValue: any): void {
  productJSON = productJSONValue;
}

export function getProduct(): any {
  return productJSON;
}

export function getForm(): any {
  return form;
}

export function clearValues(): void {
  productJSON = null;
  form = null;
}

export function isValidityDateInput(inputName: string): boolean {
  return inputName === 'startOfValidityDate' || inputName === 'endOfValidityDate';
}

export function isQuoteQuantityTotalInput(inputName: string): boolean {
  return inputName === 'quoteQuantityTotal';
}
export function isPaymentConfigurationInput(inputName: string): boolean {
  return isQuoteQuantityTotalInput(inputName) || inputName === 'paymentMethod';
}
export function isPersonIdentityCodeInput(inputName: string): boolean {
  return inputName === 'personIdentityCode';
}

export function isIntermediaryCodeInput(inputName: string): boolean {
  return inputName === 'intermediaryCode';
}

export function isIntermediaryCommissionPercent(inputName: string): boolean {
  return inputName === 'commissionPercent';
}

export function fieldsUnlockedForCoverage(inputName: string) {
  return inputName === 'clausulaAdicional' || inputName === 'coverageTextComplementary';
}

export function isBlockingDocumentInput(inputName: string): boolean {
  return inputName === 'documentType' || inputName === 'documentValue';
}

export function isEndosoBeneficiarioPreferenteSection(title: string): boolean {
  return title === 'Endoso de beneficiario preferente';
}

export function isProratedCalculationInput(inputName): boolean {
  const relevantInputs = [
    'pricingRate',
    'coverageValue',
    'declaredValue',
    'premiumValue',
    'premiumValue1',
    'premiumValue2',
    'premiumValue3',
    'premiumValue4',
    'premiumValue5',
    'premiumValue6',
    'pricingRate1',
    'pricingRate2',
    'pricingRate3',
    'pricingRate4',
    'pricingRate5',
    'pricingRate6',
    'sublimit16',
    'coverageTextComplementary'
  ];
  return relevantInputs.includes(inputName);
}
export function getProductName(): string {
  return productJSON ? productJSON?.productCode : '';
}

export function isMultirriesgoProduct(): boolean {
  const productName = getProductName();
  return productName?.includes('Multirriesgo');
}

export function isCARProduct(): boolean {
  const productName = getProductName();
  return isCountryPE() && productName?.includes('CAR');
}

export function isRCProduct(): boolean {
  const productName = getProductName();
  return isCountryPE() && productName?.includes('RC');
}

export function isEARProduct(): boolean {
  const productName = getProductName();
  return isCountryPE() && productName?.includes('EAR');
}

export function isTRECProduct(): boolean {
  const productName = getProductName();
  return productName?.includes('TREC');
}

export function isCarOrTrec(): boolean {
  const productName = getProductName();
  return productName?.includes('CAR') || productName?.includes('TREC');
}

export function isDecimalInput(type): boolean {
  return type === 'decimal';
}

export function isNumberORDecimalInput(type): boolean {
  return type === 'number' || isDecimalInput(type);
}

export function isTasaInput(inputName: string): boolean {
  return inputName === 'pricingRate';
}
export function isTransportesProduct(): boolean {
  const productName = getProductName();
  return productName?.includes('Transportes');
}

export function isTransportesCargaAbiertaProduct(): boolean {
  const productName = getProductName();
  return productName.includes('Transportes Carga Abierta');
}

export function isTransportesCargaIndividualProduct(): boolean {
  const productName = getProductName();
  return productName.includes('Transportes Carga Individual');
}

export function isCiberProduct(): boolean {
  const productName = getProductName();
  return !isCountryMX() && productName.includes('Riesgos Cibernéticos');
}

export function isTruthy(value: unknown): boolean {
  return value !== 'No' && Boolean(value);
}

export function isQuoterPE(): boolean {
  const isMultirriesgo = productJSON?.productCode?.toLowerCase()?.includes('multirriesgo');
  // const typeEndosso = localStorageService.get('endosso');
  // const isEndossoTypeValid =
  //   typeEndosso !== 'CANCEL' &&
  //   typeEndosso !== 'REACTIVACION' &&
  //   typeEndosso !== 'CESION_DERECHO' &&
  //   typeEndosso !== 'SIN_MOV_PRIMA';

  return isMultirriesgo && isCountryPE() && !isEndosso();
}

export function isvalidationsOk(): boolean {
  const validationsOk = localStorageService.get('isValidationOk');
  return validationsOk;
}

export function getMaxValueIncendio(coin: string): number {
  if (!isvalidationsOk()) return Infinity
  const risk = localStorage.getItem('riskClasificationType');
  if (risk === '1') {
    return coin === 'USD' ? 15000000 : 57000000;
  } if (risk === '2') {
    return coin === 'USD' ? 10000000 : 38000000;
  } if (risk === '3') {
    return coin === 'USD' ? 7500000 : 28500000;
  }
  return Infinity
}

export function isCarProduct(): boolean {
  const productName = getProductName();
  return productName?.includes('CAR Todo Riesgo');
}

export function isDeshonestidadProduct(): boolean {
  const productName = getProductName();
  return isCountryPE() && productName?.toLowerCase()?.includes('deshonestidad');
}
